const chatEndpoints = {
	getChats(data: any) {
		return {
			url: 'diggichat/threads',
			headers: data.headers,
			data: data.reqBody,
		};
	},
	getChatsById(data: any) {
		return {
			url: 'diggichat/thread/history',
			headers: data.headers,
			data: data.reqBody,
		};
	},
};
export default chatEndpoints;
